export function getClassStatus(status) {
  switch (status) {
    case 'PENDIENTE':
      return 'status-pending'
    case 'AUTORIZADA':
    case 'FINALIZADO':
      return 'status-authorized'
    case 'RECHAZADA':
      return 'status-rejected'
    default:
      return 'status-pending'
  }
}

export function currencyFormat(number) {
  if (!number || number === '') {
    number = 0;
  }
  if (typeof number === 'string') {
    number = parseFloat(number.replace(',', '.'));
  }
  return number ? number.toLocaleString('es-ES', { style: 'decimal', useGrouping: true, maximumFractionDigits: 2, minimumFractionDigits: 2 }) : number;
}
